import React, { useEffect, useState } from "react";
import CommonDataTable from "../CommonDataTable";
import { Button } from "antd";
import IconButton from "../IconButton";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import useGetApi from "../../services/useGetApi";

const PendingPayouts = () => {
  const [loading, setLoading] = useState(false);
  const [isLoading, error, payoutData, getData] = useGetApi(
    `payouts/status?status=0`,
    [],
    true
  );

  useEffect(() => {
    getData(`payouts/status?status=0`);
  }, []);

  const handleEdit = () => {
    console.log("edit");
  };
  const handleDelete = () => {
    console.log("handleDelete");
  };
  const handleView = () => {
    console.log("handleView");
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "user.firstName",
      key: "user.firstName",
      render: (_, record) => (
        <div>
          {record.user
            ? `${record.user.firstName}  ${record.user.lastName}`
            : "NA"}
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      key: "paymentType",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <IconButton
            icon={EditOutlined}
            onClick={handleEdit}
            style={{ color: "blue" }}
          />
          <IconButton
            icon={DeleteOutlined}
            onClick={handleDelete}
            style={{ color: "red" }}
          />
          <IconButton
            icon={EyeOutlined}
            onClick={handleView}
            style={{ color: "green" }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <CommonDataTable
        columns={columns}
        dataSource={payoutData}
        loading={loading}
        tableTitle={""}
      />
    </div>
  );
};

export default PendingPayouts;
